/*jshint esversion: 11 */
import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { updateTag } from '../../api/tag';
import PageDataLoader from '../Utility/PageDataLoader';
import Select from 'react-select';
import { tagType } from '../Utility/Enumerator';

const UpdateTagModal = ({
  modalOpenState,
  closeModalHandler,
  authUser,
  fetchNewTagList,
  tagInfoLoading,
  tagInfo
}) => {
  const [requestError, setRequestError] = useState({
    show_alert: false,
    message: ''
  });
  const [tagUpdateRequestLoading, setTagUpdateRequestLoading] = useState(false);
  const [successAlert, setSuccessAlert] = useState({
    message: '',
    show_alert: false
  });
  const [type, setType] = useState('');

  useEffect(() => {
    if (tagInfo?.type) {
      setType(tagInfo.type);
    }
  }, [tagInfo]);

  async function handleTagUpdate(event, values) {
    resetErrorAlert();
    setTagUpdateRequestLoading(true);
    const { response, error } = await updateTag(
      tagInfo._id,
      values.tag_name,
      type
    );
    setTagUpdateRequestLoading(false);
    if (error) {
      showErrorAlert(error);
      return;
    }
    closeModalHandler();
    showSuccessAlert(response.message);
    fetchNewTagList();
  }

  function showErrorAlert(message) {
    setRequestError({ message: message, show_alert: true });
  }

  function resetErrorAlert() {
    setRequestError({ message: '', show_alert: false });
  }

  function showSuccessAlert(message) {
    setSuccessAlert({ message: message, show_alert: true });
  }

  function resetSuccessAlert() {
    setSuccessAlert({ message: '', show_alert: false });
  }

  function resetState() {
    resetSuccessAlert();
    resetErrorAlert();
  }

  return (
    <React.Fragment>
      {successAlert.show_alert && (
        <SweetAlert success title="Updated" onConfirm={resetState}>
          {successAlert.message}
        </SweetAlert>
      )}
      <Modal isOpen={modalOpenState} backdrop="static" size="xl">
        <ModalHeader toggle={closeModalHandler}>
          {tagInfoLoading ? 'Loading ...' : 'Edit [' + tagInfo.name + ']'}
        </ModalHeader>
        <ModalBody>
          {tagInfoLoading ? (
            <div className="d-flex justify-content-center">
              <PageDataLoader />
            </div>
          ) : (
            <React.Fragment>
              {requestError ? (
                <Alert
                  color="danger"
                  role="alert"
                  isOpen={requestError.show_alert}
                  toggle={resetErrorAlert}
                >
                  <i className="mdi mdi-block-helper mr-2"></i>
                  {requestError.message}
                </Alert>
              ) : null}
              <AvForm
                className="needs-validation"
                onValidSubmit={handleTagUpdate}
              >
                <Row>
                  <Col md="12">
                    <FormGroup>
                      <Label>Tag Name</Label>
                      <AvField
                        name="tag_name"
                        placeholder="Enter Tag Name ..."
                        type="text"
                        className="form-control"
                        validate={{
                          required: {
                            value: true,
                            errorMessage: 'Tag name is required'
                          }
                        }}
                        defaultValue={tagInfo?.name}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <Label>Type</Label>
                      <Select
                        options={tagType}
                        placeholder={'Select...'}
                        onChange={(e) => setType(e?.value)}
                        value={tagType.find((opt) => opt.value === type)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <ModalFooter>
                  <Button
                    disabled={tagUpdateRequestLoading}
                    type="button"
                    color="light"
                    onClick={closeModalHandler}
                  >
                    Close
                  </Button>
                  <Button type="submit" color="success">
                    {tagUpdateRequestLoading ? 'Updating ...' : 'Update Tag'}
                  </Button>
                </ModalFooter>
              </AvForm>
            </React.Fragment>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(UpdateTagModal);
